/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Line, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CurrencyGbp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Line
          x1={56}
          y1={132}
          x2={136}
          y2={132}
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Path
          d="M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,75.11269-31.11271"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </G>
    </Svg>
  );
}

export default CurrencyGbp;
